// @ts-nocheck
/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Form,
  Input,
  Message,
  Modal,
  Popconfirm,
  Select,
  Space,
  Switch,
  Table,
  TableColumnProps,
  InputNumber,
  DatePicker,
  Image,
  Upload
} from '@arco-design/web-react';
import { post, get } from '../requestNew';
import dayjs from 'dayjs';

import './index.scss';
import { baseUrl } from '../utils';
import type { CouponItem } from './types';

const FormItem = Form.Item;
const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;

const formItemLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

function CouponConfig() {
  const [form] = Form.useForm<CouponItem>();
  const [formSearch] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataList, setDataList] = useState<CouponItem[]>([]);
  const [loading, setLoading] = useState(false);
  const formRef = useRef<any>({});
  // const URL_UPLOAD = baseUrl + '/sysMenu/uploadImage';
  const URL_UPLOAD = baseUrl + '/common/uploadFile';
  
  // 监听 code 字段变化
  const codeValue = Form.useWatch('code', form);

  // 卡券类型选项
  const couponTypeOptions = [
    { label: '常规赛优惠券', value: 1 },
    { label: '半年赛优惠券', value: 2 }
  ];

  // 卡券状态选项
  const isValidOptions = [
    { label: '有效', value: 1 },
    { label: '无效', value: 0 }
  ];

  // 生成卡券编码
  const generateCouponCode = (couponType: number): string => {
    const currentYear = dayjs().format('YYYY');
    if (couponType === 1) {
      // 常规赛优惠券
      return `${currentYear}_REGULAR_SESSION_COUPON_`;
    } else if (couponType === 2) {
      // 半年赛优惠券
      return `${currentYear}_HALF_YEAR_COUPON_`;
    }
    return '';
  };

  // 处理卡券类型变化
  const handleCouponTypeChange = (value: number) => {
    // 只在新增时自动生成编码（编辑时保持原编码）
    if (!formRef.current.id) {
      const code = generateCouponCode(value);
      form.setFieldValue('code', code);
    }
  };

  // 重置筛选条件
  const handleReset = () => {
    formSearch.resetFields();
    setPageNum(1);
    setPageSize(10);
    getList(true);
  };

  // 判断卡券是否可下发
  const isDistributable = (record: CouponItem): boolean => {
    // 如果状态为无效，则不可下发
    if (record.isValid !== 1) {
      return false;
    }
    // 如果已过期，则不可下发（使用 couponEndTime）
    if (record.couponEndTime) {
      const expireDate = dayjs(record.couponEndTime);
      if (expireDate.isBefore(dayjs(), 'day')) {
        return false;
      }
    }
    // 如果剩余数量为0，则不可下发
    if (record.remainingCount !== null && record.remainingCount <= 0) {
      return false;
    }
    return true;
  };

  // 表格列配置
  const columns: TableColumnProps[] = [
    {
      title: 'id',
      dataIndex: 'id',
      width: 80
    },
    {
      title: '卡券名称',
      dataIndex: 'couponName',
      width: 150
    },
    {
      title: '卡券编码',
      dataIndex: 'code',
      width: 150
    },
    {
      title: '卡券类型',
      dataIndex: 'couponType',
      width: 120,
      render: (text) => {
        const typeMap: Record<number, string> = {
          1: '常规赛优惠券',
          2: '半年赛优惠券'
        };
        return typeMap[text] || text;
      }
    },
    {
      title: '优惠金额(元)',
      dataIndex: 'couponValue',
      width: 100,
      render: (text) => {
        // couponValue 单位是元
        return text || '-';
      }
    },
    {
      title: '卡券图',
      dataIndex: 'couponPic',
      width: 100,
      render: (text) => (text && text.indexOf('http') === 0) ? (
        <Image
          src={text}
          width={50}
          height={50}
          fit="cover"
          preview={true}
          style={{ borderRadius: 4 }}
        />
      ) : '-'
    },
    {
      title: '卡券生效时间',
      dataIndex: 'couponStartTime',
      width: 150,
      render: text => text ? dayjs(text).format('YYYY-MM-DD') : '-'
    },
    {
      title: '卡券过期时间',
      dataIndex: 'couponEndTime',
      width: 150,
      render: text => text ? dayjs(text).format('YYYY-MM-DD') : '-'
    },
    {
      title: '有效天数（旧版）',
      dataIndex: 'expireDays',
      width: 150,
      render: text => text || '-'
    },
    {
      title: '是否有效',
      dataIndex: 'isValid',
      width: 100,
      render: (text, record) => (
        <Switch
          checked={text === 1}
          onChange={val => handleIsValidChange(val, record)}
        />
      )
    },
    {
      title: '卡券状态',
      dataIndex: 'status',
      width: 120,
      render: (_, record) => {
        const distributable = isDistributable(record);
        return distributable ? (
          <Button type="primary" size="small" style={{ backgroundColor: '#00B42A', borderColor: '#00B42A' }}>可下发</Button>
        ) : (
          <Button type="secondary" size="small" style={{ backgroundColor: '#F2F3F5', borderColor: '#F2F3F5', color: '#4E5969' }}>不可下发</Button>
        );
      }
    },
    {
      title: '发行总量',
      dataIndex: 'totalCount',
      width: 100,
      render: text => text !== null && text !== undefined ? text : '不限'
    },
    {
      title: '发行人次',
      dataIndex: 'remainingCount',
      width: 100,
      render: (text, record) => {
        // 这里显示已发行数量 = 总量 - 剩余量
        if (record.totalCount === null || record.totalCount === undefined) {
          return '-';
        }
        const issued = (record.totalCount || 0) - (text || 0);
        return issued;
      }
    },
    {
      title: '单人最多张数',
      dataIndex: 'maxCountPerUser',
      width: 120,
      render: text => text !== null && text !== undefined ? text : '-'
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 150,
      render: (_, record: CouponItem) => (
        <>
          <Button className="btn" type="text" onClick={() => edit(record)} loading={loading}>
            编辑
          </Button>
          {/* <Popconfirm focusLock title="提示" content="是否确认删除?" onOk={() => del(record)}>
            <Button className="btn" type="text" status="danger" loading={loading}>
              删除
            </Button>
          </Popconfirm> */}
        </>
      )
    }
  ];

  // 处理是否有效开关变更
  const handleIsValidChange = (val: boolean, record: CouponItem) => {
    const isValid = val ? 1 : 0;
    setLoading(true);

    post(`/coupon/update/${record.id}`, { ...record, isValid })
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('操作成功');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 获取数据列表
  const getList = (reset?: boolean) => {
    setLoading(true);
    if (reset) {
      setPageNum(1);
      setPageSize(10);
    }

    const params = {
      ...formSearch.getFieldsValue(),
      pageNum,
      pageSize
    };

    get('/coupon/list', params)
      .then((res: any) => {
        const { list, total } = res.data || {};
        setTotal(total);
        setDataList(list || []);
      })
      .catch(() => {
        Message.error('获取数据失败!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 新增卡券 设置新卡券的数据
  const add = () => {
    formRef.current = {};
    form.resetFields();
    form.setFieldsValue({
      couponPic: '',
      couponPicUsed: '',
      isValid: 1
    });
    setVisible(true);
  };

  // 删除卡券
  const del = (record: CouponItem) => {
    setLoading(true);
    post(`/coupon/delete/${record.id}`)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('删除成功！');
          getList();
        } else {
          Message.error(message);
        }
      })
      .catch(() => {
        Message.error('网络错误!');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 编辑卡券
  const edit = (record: CouponItem) => {
    formRef.current = record;
    form.setFieldsValue({
      ...record,
      isValid: record.isValid === 1,
      couponValue: record.couponValue, // couponValue 单位是元
      couponTimeRange: record.couponStartTime && record.couponEndTime ? [
        dayjs(record.couponStartTime),
        dayjs(record.couponEndTime)
      ] : null
    });
    setVisible(true);
  };

  // 取消编辑
  const editCancel = () => {
    formRef.current = {};
    setVisible(false);
    form.resetFields();
  };

  // 提交表单
  const onOk = () => {
    form.validate().then(values => {
      setLoading(true);
      const data = {
        ...formRef.current,
        ...values,
        isValid: values.isValid ? 1 : 0,
        couponValue: values.couponValue || 0, // couponValue 单位是元
        couponStartTime: values.couponTimeRange && values.couponTimeRange.length === 2 
          ? dayjs(values.couponTimeRange[0]).format('YYYY-MM-DD') 
          : null,
        couponEndTime: values.couponTimeRange && values.couponTimeRange.length === 2 
          ? dayjs(values.couponTimeRange[1]).format('YYYY-MM-DD') 
          : null
      };

      // 删除临时的 range 字段
      delete data.couponTimeRange;

      // 计算有效期天数（从生效时间到过期时间的天数，包含起始和结束日期）
      if (data.couponStartTime && data.couponEndTime) {
        const startDate = dayjs(data.couponStartTime);
        const endDate = dayjs(data.couponEndTime);
        data.expireDays = endDate.diff(startDate, 'day') + 1; // +1 因为包含起始和结束日期
      } else {
        data.expireDays = 0;
      }

      const url = formRef.current.id ? `/coupon/update/${formRef.current.id}` : `/coupon/create`;

      post(url, data)
        .then((res: any) => {
          const { code, message } = res || {};
          if (code === 200) {
            Message.success(formRef.current.id ? '编辑成功！' : '新增成功！');
            getList();
            editCancel();
          } else {
            Message.error(message);
          }
        })
        .catch(e => {
          Message.error('网络错误!');
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }).catch(() => {
      Message.error('请检查表单填写是否正确!');
    });
  };

  useEffect(() => {
    getList();
  }, [pageNum, pageSize]);

  return (
    <div className="coupon-config table-flex">
      <Space style={{ flexWrap: 'wrap', marginBottom: 16 }}>
        <Form style={{ width: '100%' }} autoComplete="off" layout="inline" form={formSearch}>
          <FormItem label="卡券类型" field="couponType">
            <Select style={{ width: 150 }} allowClear placeholder="请选择">
              {couponTypeOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="卡券状态" field="isValid">
            <Select style={{ width: 120 }} allowClear placeholder="请选择">
              {isValidOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={() => getList(true)} loading={loading}>
              查询
            </Button>
          </FormItem>
          <FormItem>
            <Button type="outline" onClick={handleReset} loading={loading}>
              重置
            </Button>
          </FormItem>
          <FormItem>
            <Button className="filter-item" type="primary" onClick={add} loading={loading}>
              新增卡券
            </Button>
          </FormItem>
        </Form>
      </Space>
      <div className="table-content">
        <Table
          rowKey="id"
          columns={columns}
          data={dataList}
          className="table-scroll"
          pagination={{
            sizeCanChange: true,
            pageSize,
            total,
            showTotal: true,
            current: pageNum,
            onChange: (num, size) => {
              setPageNum(num);
              if (size && size !== pageSize) {
                setPageSize(size);
              }
            }
          }}
          scroll={{ y: '100%', x: '100%' }}
          loading={loading}
        />
      </div>
      <Modal
        title={formRef.current.id ? '编辑卡券' : '新增卡券'}
        visible={visible}
        onCancel={editCancel}
        onOk={onOk}
        unmountOnExit
        style={{ width: 600 }}
        confirmLoading={loading}
      >
        <Form {...formItemLayout} form={form}>
          <FormItem label="卡券名称" field="couponName" rules={[{ required: true, message: '请输入卡券名称' }]}>
            <Input placeholder="请输入..." />
          </FormItem>
          <FormItem label="卡券类型" field="couponType" rules={[{ required: true, message: '请选择卡券类型' }]}>
            <Select placeholder="请选择" onChange={handleCouponTypeChange}>
              {couponTypeOptions.map(option => (
                <Option key={option.value} value={option.value}>{option.label}</Option>
              ))}
            </Select>
          </FormItem>
          <FormItem label="卡券编码" field="code" rules={[{ required: true, message: '请输入卡券编码' }]}>
            <Input 
              placeholder="请输入..." 
              disabled={!codeValue}
            />
          </FormItem>
          <FormItem label="优惠金额(元)" field="couponValue" rules={[{ required: true, message: '请输入优惠金额' }]}>
            <InputNumber placeholder="请输入..." style={{ width: '100%' }} min={0} precision={2} />
          </FormItem>
          <FormItem label="卡券图(使用前)" field="couponPic">
            <Upload
              action={URL_UPLOAD}
              headers={{
                'Authorization': `${localStorage.getItem('authToken')}`
              }}
              defaultFileList={form.getFieldValue('couponPic') ? [{ url: form.getFieldValue('couponPic'), uid: '-1', name: 'couponPic' }] : []}
              onChange={(_, file) => {
                if (file?.response?.data) {
                  form.setFieldValue('couponPic', file.response.data);
                }
              }}
              onRemove={() => {
                form.setFieldValue('couponPic', '');
              }}
              limit={1}
              imagePreview
              listType="picture-card"
              multiple={false}
              accept="image/*"
            />
          </FormItem>
          <FormItem label="卡券图(使用后)" field="couponPicUsed">
            <Upload
              action={URL_UPLOAD}
              headers={{
                'Authorization': `${localStorage.getItem('authToken')}`
              }}
              defaultFileList={form.getFieldValue('couponPicUsed') ? [{ url: form.getFieldValue('couponPicUsed'), uid: '-1', name: 'couponPicUsed' }] : []}
              onChange={(_, file) => {
                if (file?.response?.data) {
                  form.setFieldValue('couponPicUsed', file.response.data);
                }
              }}
              onRemove={() => {
                form.setFieldValue('couponPicUsed', '');
              }}
              limit={1}
              imagePreview
              listType="picture-card"
              multiple={false}
              accept="image/*"
            />
          </FormItem>
          <FormItem label="是否有效" field="isValid" triggerPropName="checked">
            <Switch />
          </FormItem>
          <FormItem label="卡券生效时间" field="couponTimeRange">
            <RangePicker
              placeholder={['开始时间', '结束时间']}
              style={{ width: '100%' }}
              showTime={false}
            />
          </FormItem>
          <FormItem label="单人最多张数" field="maxCountPerUser">
            <InputNumber 
              placeholder="请输入单人最多张数" 
              style={{ width: '100%' }} 
              min={0} 
              precision={0}
            />
          </FormItem>
        </Form>
      </Modal>
    </div>
  );
}

export default CouponConfig;

